import React, { useState } from 'react';
import StatsBarChart from '../charts/StatsBarChart';
import type { YearStats, StatsChartData, RegionStats } from '../statsTypes';
import { resolveRegionStats, canonicalRegionLabel } from '../regionResolver';

const REGIONS = ['NT Total', 'Beaufort Delta', 'Sahtu', 'South Slave', 'North Slave', 'Deh Cho'];

interface ToDateTabProps {
  data: YearStats | null;
  dayOfYear?: number;
}

function getRegionStats(data: YearStats, regionName: string): RegionStats | null {
  if (regionName === 'NT Total') return data.totals;
  return resolveRegionStats(data.regions, regionName);
}

const ToDateTab: React.FC<ToDateTabProps> = ({ data, dayOfYear }) => {
  const [activeRegion, setActiveRegion] = useState('NT Total');

  if (!data) return <p>No data available</p>;

  const stats = getRegionStats(data, activeRegion);

  const fireComparison: StatsChartData[] = Object.entries(data.regions).map(([name, s]) => ({
    name: canonicalRegionLabel(name),
    value: s.total_fires,
  }));

  const areaComparison: StatsChartData[] = Object.entries(data.regions).map(([name, s]) => ({
    name: canonicalRegionLabel(name),
    value: s.total_area,
  }));

  return (
    <div className="stats-year-tab">
      <p className="stats-todate-caption">
        10-year average as of day {dayOfYear ?? '—'} of the year (to-date, for the weekly DM report)
      </p>
      <div className="stats-sub-tabs">
        {REGIONS.map(region => (
          <button
            key={region}
            className={`stats-sub-tab ${activeRegion === region ? 'stats-sub-tab--active' : ''}`}
            onClick={() => setActiveRegion(region)}
          >
            {region}
          </button>
        ))}
      </div>
      {stats && (
        <>
          <div className="stats-todate-headline">
            <div className="stats-todate-metric">
              <span className="stats-todate-metric__label">Fire Frequency</span>
              <span className="stats-todate-metric__value">{stats.total_fires}</span>
            </div>
            <div className="stats-todate-metric">
              <span className="stats-todate-metric__label">Hectares Burned</span>
              <span className="stats-todate-metric__value">{Math.round(stats.total_area).toLocaleString()}</span>
            </div>
          </div>
          <div className="stats-charts-grid">
            <StatsBarChart data={fireComparison} title="Regional Fire Frequency (10Y To-Date)" color="#1976D2" />
            <StatsBarChart data={areaComparison} title="Regional Hectares Burned (10Y To-Date)" color="#F57C00" />
          </div>
        </>
      )}
    </div>
  );
};

export default ToDateTab;
